

export const zoomPercent = (width) => {
    let zoomPercent = '100%'

    if (width < 1700 && width > 1400) {
        zoomPercent = '88%'

    }

    if (width <= 1400 && width > 900) {
        zoomPercent = '80%'

    }
    return zoomPercent

}

export const zoomPercentUOABoard = (width) => {
    let zoomPercent = '100%'

    if (width < 1700 && width > 1400) {
        zoomPercent = '88%'

    }

    if (width <= 1400 && width > 1281) {
        zoomPercent = '82%'

    }

    if (width <= 1280 && width > 900) {
        zoomPercent = '73%'

    }
    return zoomPercent

}


// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/zoomFunction.js